import React, { useState } from 'react';
import { Menu } from '@headlessui/react';
import { useNavigate } from 'react-router-dom';
import { useUserProfile } from '../../hooks/useUserProfile';
import logo from '../../assets/images/logo-box.png';
import { getOrgDisplayName } from '../../utils/userProfileHelpers';
import { supabase } from '../../services/supabase';
import ContactSupportModal from '../support/ContactSupportModal';
import ReportProblemModal from '../support/ReportProblemModal';

const HeaderUserChip: React.FC = () => {
  const { profile, loading, user } = useUserProfile();
  const navigate = useNavigate();

  const [isSupportOpen, setIsSupportOpen] = useState(false);
  const [isReportProblemOpen, setIsReportProblemOpen] = useState(false);

  if (loading || !profile) return null;

  const displayName = profile.first_name || (user?.email?.split('@')[0] ?? 'User');

  return (
    <>
      <Menu as="div" className="relative inline-block text-left">
        <Menu.Button
          className="flex items-center gap-2 text-sm font-medium text-textPrimary hover:text-primary cursor-pointer"
          title={user?.email || ''}
        >
          <img
            src={logo}
            alt="Ballotr Logo"
            className="w-10 h-10 rounded-full border border-gray-300 bg-white p-1 object-contain"
          />
          {displayName}
        </Menu.Button>

        <Menu.Items className="absolute right-0 mt-2 w-56 origin-top-right bg-white border border-gray-200 divide-y divide-gray-100 rounded-md shadow-lg focus:outline-none z-50">
          <div className="px-4 py-3">
            <p className="text-sm font-medium text-gray-900">{displayName}</p>
            <p className="text-xs text-gray-500">{getOrgDisplayName(profile)}</p>
          </div>

          <div className="py-1">
            <Menu.Item>
              {({ active }) => (
                <button
                  onClick={() => navigate('/profile')}
                  className={`${active ? 'bg-gray-100' : ''} w-full text-left px-4 py-2 text-sm text-gray-700`}
                >
                  My Profile
                </button>
              )}
            </Menu.Item>

            <Menu.Item>
              {({ active }) => (
                <button
                  onClick={() => setIsSupportOpen(true)}
                  className={`${active ? 'bg-gray-100' : ''} w-full text-left px-4 py-2 text-sm text-gray-700`}
                >
                  Contact Support
                </button>
              )}
            </Menu.Item>

            <Menu.Item>
              {({ active }) => (
                <button
                  onClick={() => setIsReportProblemOpen(true)}
                  className={`${active ? 'bg-gray-100' : ''} w-full text-left px-4 py-2 text-sm text-gray-700`}
                >
                  Report a Problem
                </button>
              )}
            </Menu.Item>
          </div>

          <div className="py-1">
            <Menu.Item>
              {({ active }) => (
                <button
                  onClick={() => navigate('/privacy')}
                  className={`${active ? 'bg-gray-100' : ''} w-full text-left px-4 py-2 text-sm text-gray-700`}
                >
                  Privacy Policy
                </button>
              )}
            </Menu.Item>

            <Menu.Item>
              {({ active }) => (
                <button
                  onClick={() => navigate('/terms')}
                  className={`${active ? 'bg-gray-100' : ''} w-full text-left px-4 py-2 text-sm text-gray-700`}
                >
                  Terms of Service
                </button>
              )}
            </Menu.Item>
          </div>

          <div className="py-1">
            <Menu.Item>
              {({ active }) => (
                <button
                  onClick={async () => {
                    await supabase.auth.signOut();
                    navigate('/');
                  }}
                  className={`${active ? 'bg-gray-100' : ''} w-full text-left px-4 py-2 text-sm text-red-600`}
                >
                  Sign Out
                </button>
              )}
            </Menu.Item>
          </div>
        </Menu.Items>
      </Menu>

      <ContactSupportModal
        isOpen={isSupportOpen}
        onClose={() => setIsSupportOpen(false)}
        userEmail={user?.email}
        userId={user?.id}
      />

      <ReportProblemModal
        isOpen={isReportProblemOpen}
        onClose={() => setIsReportProblemOpen(false)}
        userEmail={user?.email}
        userId={user?.id}
      />
    </>
  );
};

export default HeaderUserChip;